import { render, staticRenderFns } from "./tabulation.vue?vue&type=template&id=01622e10&scoped=true&"
import script from "./tabulation.vue?vue&type=script&lang=js&"
export * from "./tabulation.vue?vue&type=script&lang=js&"
import style1 from "./tabulation.vue?vue&type=style&index=1&id=01622e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01622e10",
  null
  
)

export default component.exports